module.exports = __webpack_public_path__ + "img/Painel 1.9f2d4ffa.jpg";